// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-modal[data-v-4dcdc4a2] .el-dialog {
  top: 0 !important;
}
.full-modal[data-v-4dcdc4a2] .el-dialog__header .right {
  z-index: 999;
}
.full-modal[data-v-4dcdc4a2] .el-dialog__headerbtn {
  z-index: 999;
}
.full-modal[data-v-4dcdc4a2] .el-dialog__headerbtn .el-dialog__close {
  font-size: 28px;
  color: #000;
}
.full-modal[data-v-4dcdc4a2] .el-dialog__body {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/FullModal/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EAEI,iBAAA;ACDJ;ADDA;EAMM,YAAA;ACFN;ADJA;EAUI,YAAA;ACHJ;ADPA;EAYM,eAAA;EACA,WAAA;ACFN;ADXA;EAiBI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;ACHJ","sourcesContent":["\n.full-modal {\n  ::v-deep .el-dialog {\n    top: 0 !important;\n  }\n  ::v-deep .el-dialog__header {\n    .right {\n      z-index: 999;\n    }\n  }\n  ::v-deep .el-dialog__headerbtn {\n    z-index: 999;\n    .el-dialog__close {\n      font-size: 28px;\n      color: #000;\n    }\n  }\n  ::v-deep .el-dialog__body {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n  }\n}\n",".full-modal ::v-deep .el-dialog {\n  top: 0 !important;\n}\n.full-modal ::v-deep .el-dialog__header .right {\n  z-index: 999;\n}\n.full-modal ::v-deep .el-dialog__headerbtn {\n  z-index: 999;\n}\n.full-modal ::v-deep .el-dialog__headerbtn .el-dialog__close {\n  font-size: 28px;\n  color: #000;\n}\n.full-modal ::v-deep .el-dialog__body {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
